import "core-js/modules/es.array.every";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.some";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { cloneDeep } from 'lodash';
export default {
  meta: {
    title: '配送区域管理',
    auth: true,
    authorityValue: "store-delivery-area"
  },
  name: 'distributionArea',
  data: function data() {
    return {
      checkAll: false,
      checkAlltwo: false,
      positionAuthorities: [],
      mainlandProvinces: [],
      hmtProvinces: [],
      storeId: ''
    };
  },
  computed: {
    isIndeterminateAll: function isIndeterminateAll() {
      var nate = this.mainlandProvinces.some(function (v) {
        return v.selected || v.indeterminate;
      });
      return nate && !this.checkAll;
    },
    isIndeterminateAlltwo: function isIndeterminateAlltwo() {
      var nate = this.hmtProvinces.some(function (v) {
        return v.selected || v.indeterminate;
      });
      return nate && !this.checkAlltwo;
    }
  },
  watch: {
    mainlandProvinces: {
      handler: function handler(val) {
        var all = val.every(function (v) {
          return v.selected;
        });
        this.checkAll = all;
      },
      deep: true
    },
    hmtProvinces: {
      handler: function handler(val) {
        var all = val.every(function (v) {
          return v.selected;
        });
        this.checkAlltwo = all;
      },
      deep: true
    }
  },
  created: function created() {
    this.dataBind();
  },
  methods: {
    //递归全选/全不选
    forSelected: function forSelected(arr, flog) {
      var _this = this;

      arr.forEach(function (v) {
        _this.$set(v, 'selected', flog);

        if (v.cities && v.cities.length > 0) {
          _this.forSelected(v.cities, flog);
        }
      });
    },
    //中国港澳台权限
    handleCheckAllChangetwo: function handleCheckAllChangetwo() {
      this.forSelected(this.hmtProvinces, this.checkAlltwo);
    },
    //中国大陆权限
    handleCheckAllChange: function handleCheckAllChange() {
      this.forSelected(this.mainlandProvinces, this.checkAll);
    },
    //单个省份全选
    handleCheckChange: function handleCheckChange(e, l) {
      l.indeterminate = false;
      this.forSelected(l.cities, e);
    },
    clickPop: function clickPop(l) {
      var all = l.cities.every(function (v) {
        return v.selected;
      });
      var indeterminate = l.cities.some(function (v) {
        return v.selected;
      });
      l.indeterminate = all ? false : indeterminate;
      l.selected = all;
    },
    dataBind: function dataBind(data) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$api.getDeliveryArea();

              case 2:
                res = _context.sent;
                _this2.storeId = res.storeId;
                _this2.mainlandProvinces = cloneDeep(res.mainlandProvinces);

                _this2.mainlandProvinces.forEach(function (v) {
                  _this2.$set(v, 'selected', v.cities.every(function (s) {
                    return s.selected;
                  }));

                  _this2.$set(v, 'indeterminate', v.cities.every(function (s) {
                    return s.selected;
                  }) ? false : v.cities.some(function (s) {
                    return s.selected;
                  }));
                });

                _this2.hmtProvinces = cloneDeep(res.hmtProvinces);

                _this2.hmtProvinces.forEach(function (v) {
                  _this2.$set(v, 'selected', v.cities.every(function (s) {
                    return s.selected;
                  }));

                  _this2.$set(v, 'indeterminate', v.cities.every(function (s) {
                    return s.selected;
                  }) ? false : v.cities.some(function (s) {
                    return s.selected;
                  }));
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    confirm: function confirm() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, mainlandProvinces, hmtProvinces;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  wholeCountry: false,
                  mainlandProvinces: _this3.mainlandProvinces,
                  hmtProvinces: _this3.hmtProvinces,
                  storeId: _this3.storeId
                }; //国内

                mainlandProvinces = params.mainlandProvinces.every(function (v) {
                  return v.selected;
                }); //港澳台

                hmtProvinces = params.hmtProvinces.every(function (v) {
                  return v.selected;
                });
                params.wholeCountry = mainlandProvinces && hmtProvinces;
                _context2.next = 6;
                return _this3.$api.saveDeliveryArea(params);

              case 6:
                YL.message('保存成功');

                _this3.goBack();

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};